import { apiClient } from '../client';
import { dineEndpoints } from '../endpoints/dine.endpoints';
import { call } from './unwrap';
import type { SectionDto } from '../types/dine.types';

export const sectionService = {
  /** GET /sections — the outlet's active sections, in floor order. */
  list(): Promise<SectionDto[]> {
    return call<{ items?: SectionDto[] } | SectionDto[]>(apiClient.get(dineEndpoints.sections()), 'Could not load the sections').then((d) =>
      (Array.isArray(d) ? d : d?.items ?? []).filter((s) => s.isActive),
    );
  },
};
